// 게임 엔티티들의 초기화를 담당하는 클래스
class EntitiesInitializer {
  constructor(game) {
    this.game = game;
  }

  // 게임 엔티티 초기화
  async initialize() {
    // Utils.log("게임 엔티티 초기화 중...");

    // 플레이어 생성
    await this.initializePlayer();

    // 아이템 시스템 초기화
    await this.initializeItemSystem();

    // 적 스폰 시스템 초기화
    await this.initializeEnemySpawnSystem();

    // 동료 시스템 초기화
    await this.initializeCompanionSystem();

    // Utils.log("게임 엔티티 초기화 완료");
  }

  // 플레이어 초기화
  async initializePlayer() {
    this.game.player = new Player(this.game.scene);
    await this.game.player.init();

    // 한국어 주석: 플레이어의 baseStats 초기화 (파티 버프 적용을 위한 기준값 설정)
    if (this.game.player.updateBaseStats) {
      this.game.player.updateBaseStats();
    }

    // 플레이어에게 환경 오브젝트 참조 제공
    this.game.sceneManager.setupCollisionForPlayer(this.game.player);
  }

  // 아이템 시스템 초기화
  async initializeItemSystem() {
    // Utils.log("아이템 시스템 초기화 중...");

    // 아이템 매니저 생성
    this.game.itemManager = new ItemManager(
      this.game.scene,
      this.game.camera,
      this.game.player
    );

    // Utils.log("아이템 시스템 초기화 완료");
  }

  // 적 스폰 시스템 초기화
  async initializeEnemySpawnSystem() {
    // Utils.log("적 스폰 시스템 초기화 중...");

    // 적 스폰 매니저 생성 (모델 캐시는 이미 GameInitializer에서 완료됨)
    this.game.enemySpawnManager = new EnemySpawnManager(
      this.game.scene,
      this.game.camera,
      this.game.player
    );

    // 환경 오브젝트 설정
    this.game.enemySpawnManager.setEnvironmentObjects(
      this.game.sceneManager.getEnvironmentObjects()
    );

    // 스폰 스케줄러 생성 (게임 인스턴스도 전달하여 UI 매니저 접근 가능하도록)
    this.game.spawnScheduler = new SpawnScheduler(
      this.game.enemySpawnManager,
      this.game
    );

    // 스폰 시스템 시작은 코디네이터를 통해 단일 진입점으로 처리
    // 한국어 주석: 이제부터 모든 스폰은 코디네이터의 initSpawns()만 사용
    // Utils.log("EntitiesInitializer에서 스폰 시스템 초기화 시도");

    if (!this.game.coordinator) {
      // Utils.log(
      //   "coordinator가 없습니다! 스폰 시스템을 직접 시작합니다.",
      //   "warn"
      // );
      // coordinator가 없으면 직접 스폰 시스템 시작
      if (this.game.spawnScheduler) {
        const timeline = EnemySpawnConfig.getTimeline();
        this.game.spawnScheduler.startTimeline(timeline);
        // Utils.log("스폰 시스템이 직접 시작되었습니다.");
      }
      return;
    }

    if (!this.game.coordinator.initSpawns) {
      // Utils.log(
      //   "coordinator.initSpawns 함수가 없습니다! 스폰 시스템을 직접 시작합니다.",
      //   "warn"
      // );
      // initSpawns 함수가 없으면 직접 스폰 시스템 시작
      if (this.game.spawnScheduler) {
        const timeline = EnemySpawnConfig.getTimeline();
        this.game.spawnScheduler.startTimeline(timeline);
        // Utils.log("스폰 시스템이 직접 시작되었습니다.");
      }
      return;
    }

    // Utils.log("coordinator와 initSpawns 함수 존재 확인됨");
    this.game.coordinator.initSpawns();

    // Utils.log("적 스폰 시스템 초기화 완료");
  }

  // 한국어 주석: 초기 스폰 스케줄링은 제거되었음. 타임라인으로 일원화됨.

  // 동료 시스템 초기화
  async initializeCompanionSystem() {
    // Utils.log("동료 시스템 초기화 중...");

    // 동료 매니저 생성 (GameStateManager는 나중에 초기화되므로 임시로 null 전달)
    this.game.companionManager = new CompanionManager(
      this.game.scene,
      this.game.player,
      null // GameStateManager는 Game.js에서 나중에 설정됨
    );

    // EnemySpawnManager에 CompanionManager 참조 설정 (부채꼴 공격용 적 목록 동기화)
    if (this.game.enemySpawnManager) {
      this.game.enemySpawnManager.setCompanionManager(
        this.game.companionManager
      );
    }

    // ItemManager에 CompanionManager 참조 설정 (하트 아이템 회복용)
    if (this.game.itemManager) {
      this.game.itemManager.setCompanionManager(this.game.companionManager);
    }

    // Utils.log("동료 시스템 초기화 완료");
  }
}

// webpack 빌드를 위해 default export 추가
export default EntitiesInitializer;
